// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: zrtWnXAJRs5
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import TopBar from "../../TopBar"; // plasmic-import: MnkTdPJ0xv/component
import TimeSelectStack from "../../TimeSelectStack"; // plasmic-import: diN_Py79HQ/component
import GraphStack from "../../GraphStack"; // plasmic-import: KHgbr-NCRC/component
import DashboardPaymentsCard from "../../DashboardPaymentsCard"; // plasmic-import: sAZglV6OPm/component
import DashboardContractsCard from "../../DashboardContractsCard"; // plasmic-import: tonUNM2F_O_/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicDashboard3.module.css"; // plasmic-import: zrtWnXAJRs5/css

createPlasmicElementProxy;

export const PlasmicDashboard3__VariantProps = new Array();

export const PlasmicDashboard3__ArgProps = new Array(
  "startDate",
  "endDate",
  "accountBalance",
  "payouts",
  "totalBalance"
);

const $$ = {};

function PlasmicDashboard3__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div
            data-plasmic-name={"vertStack"}
            data-plasmic-override={overrides.vertStack}
            className={classNames(projectcss.all, sty.vertStack)}
          >
            <TopBar
              className={classNames("__wab_instance", sty.topBar__rhwVs)}
            />

            <TopBar
              className={classNames("__wab_instance", sty.topBar__b3HIj)}
              userNameText={"Jones Ferdinand"}
            />

            <div
              data-plasmic-name={"sheet"}
              data-plasmic-override={overrides.sheet}
              className={classNames(projectcss.all, sty.sheet)}
            >
              <div
                data-plasmic-name={"graphParentStack"}
                data-plasmic-override={overrides.graphParentStack}
                className={classNames(projectcss.all, sty.graphParentStack)}
              >
                <TimeSelectStack
                  data-plasmic-name={"timeSelectStack"}
                  data-plasmic-override={overrides.timeSelectStack}
                  className={classNames("__wab_instance", sty.timeSelectStack)}
                />

                <div
                  data-plasmic-name={"amountStack"}
                  data-plasmic-override={overrides.amountStack}
                  className={classNames(projectcss.all, sty.amountStack)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "$0.00",
                    value: args.totalBalance,
                    className: classNames(sty.slotTargetTotalBalance)
                  })}
                </div>
                <GraphStack
                  data-plasmic-name={"graphStack"}
                  data-plasmic-override={overrides.graphStack}
                  className={classNames("__wab_instance", sty.graphStack)}
                />

                <div
                  data-plasmic-name={"graphLine"}
                  data-plasmic-override={overrides.graphLine}
                  className={classNames(projectcss.all, sty.graphLine)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__gZcnX)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "June 19, 2022",
                      value: args.startDate,
                      className: classNames(sty.slotTargetStartDate)
                    })}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__nzs3Z)}
                  >
                    {p.renderPlasmicSlot({
                      defaultContents: "June 19, 2022",
                      value: args.endDate,
                      className: classNames(sty.slotTargetEndDate)
                    })}
                  </div>
                </div>
              </div>
              <p.Stack
                as={"div"}
                data-plasmic-name={"figmaPaste2"}
                data-plasmic-override={overrides.figmaPaste2}
                hasGap={true}
                className={classNames(projectcss.all, sty.figmaPaste2)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__sQdJa
                  )}
                >
                  {"USD Balance"}
                </div>
                {p.renderPlasmicSlot({
                  defaultContents: (
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zdVxf
                      )}
                    >
                      {"$0.00"}
                    </div>
                  ),

                  value: args.accountBalance,
                  className: classNames(sty.slotTargetAccountBalance)
                })}
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__e25Vk
                  )}
                >
                  {"Payouts"}
                </div>
                <div
                  data-plasmic-name={"payouts"}
                  data-plasmic-override={overrides.payouts}
                  className={classNames(projectcss.all, sty.payouts)}
                >
                  {p.renderPlasmicSlot({
                    defaultContents: "$0.00",
                    value: args.payouts,
                    className: classNames(sty.slotTargetPayouts)
                  })}
                </div>
              </p.Stack>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__cK1TP)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__jxrde)}>
                <div className={classNames(projectcss.all, sty.freeBox__e63Yu)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qsUob
                    )}
                  >
                    {"Payments"}
                  </div>
                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View All"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"paymentCardStack"}
                  data-plasmic-override={overrides.paymentCardStack}
                  className={classNames(projectcss.all, sty.paymentCardStack)}
                >
                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard__idYcT
                    )}
                    client={"McDonalds"}
                  />

                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard___0YuG
                    )}
                  />

                  <DashboardPaymentsCard
                    amount={"$1040.00"}
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardPaymentsCard__sWUcs
                    )}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__vMg4)}>
                <div className={classNames(projectcss.all, sty.freeBox__aIyyu)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___1IbCe
                    )}
                  >
                    {"Contracts"}
                  </div>
                  <div
                    data-plasmic-name={"viewDetails2"}
                    data-plasmic-override={overrides.viewDetails2}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails2
                    )}
                  >
                    {"View All"}
                  </div>
                </div>
                <div
                  data-plasmic-name={"contractCardStack"}
                  data-plasmic-override={overrides.contractCardStack}
                  className={classNames(projectcss.all, sty.contractCardStack)}
                >
                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__kmAJz
                    )}
                    client={"McDonalds client"}
                  />

                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__lkrzc
                    )}
                  />

                  <DashboardContractsCard
                    className={classNames(
                      "__wab_instance",
                      sty.dashboardContractsCard__bAYdg
                    )}
                  />
                </div>
              </div>
            </p.Stack>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "vertStack",
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "payouts",
    "viewDetails",
    "paymentCardStack",
    "viewDetails2",
    "contractCardStack"
  ],

  sidebar: ["sidebar"],
  vertStack: [
    "vertStack",
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "payouts",
    "viewDetails",
    "paymentCardStack",
    "viewDetails2",
    "contractCardStack"
  ],

  sheet: [
    "sheet",
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine",
    "figmaPaste2",
    "payouts"
  ],

  graphParentStack: [
    "graphParentStack",
    "timeSelectStack",
    "amountStack",
    "graphStack",
    "graphLine"
  ],

  timeSelectStack: ["timeSelectStack"],
  amountStack: ["amountStack"],
  graphStack: ["graphStack"],
  graphLine: ["graphLine"],
  figmaPaste2: ["figmaPaste2", "payouts"],
  payouts: ["payouts"],
  viewDetails: ["viewDetails"],
  paymentCardStack: ["paymentCardStack"],
  viewDetails2: ["viewDetails2"],
  contractCardStack: ["contractCardStack"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDashboard3__ArgProps,
          internalVariantPropNames: PlasmicDashboard3__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDashboard3__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboard3";
  } else {
    func.displayName = `PlasmicDashboard3.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboard3 = Object.assign(
  // Top-level PlasmicDashboard3 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    vertStack: makeNodeComponent("vertStack"),
    sheet: makeNodeComponent("sheet"),
    graphParentStack: makeNodeComponent("graphParentStack"),
    timeSelectStack: makeNodeComponent("timeSelectStack"),
    amountStack: makeNodeComponent("amountStack"),
    graphStack: makeNodeComponent("graphStack"),
    graphLine: makeNodeComponent("graphLine"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    payouts: makeNodeComponent("payouts"),
    viewDetails: makeNodeComponent("viewDetails"),
    paymentCardStack: makeNodeComponent("paymentCardStack"),
    viewDetails2: makeNodeComponent("viewDetails2"),
    contractCardStack: makeNodeComponent("contractCardStack"),
    // Metadata about props expected for PlasmicDashboard3
    internalVariantProps: PlasmicDashboard3__VariantProps,
    internalArgProps: PlasmicDashboard3__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicDashboard3;
/* prettier-ignore-end */
